import { useEffect, useState } from 'react'

import { useIsMounted } from '../useIsMounted'

export default function usePublications(participant) {
    const [publications, setPublications] = useState([])

    const isMounted = useIsMounted()

    useEffect(() => {
        // Reset the publications when the 'participant' variable changes.
        if (!participant) return
        setPublications(Array.from(participant.tracks.values()))

        const publicationAdded = publication =>
            isMounted.current &&
            setPublications(prevPublications => [
                ...prevPublications,
                publication,
            ])

        const publicationRemoved = publication =>
            isMounted.current &&
            setPublications(prevPublications =>
                prevPublications.filter(p => p !== publication)
            )

        participant.on('trackPublished', publicationAdded)
        participant.on('trackUnpublished', publicationRemoved)
        return () => {
            participant.off('trackPublished', publicationAdded)
            participant.off('trackUnpublished', publicationRemoved)
        }
    }, [participant])

    return publications
}
